import { TBooleanInNumber, TTranslate } from '~/types/main';

export const checkoutProfileCast = (data: any) => ({
  id: Number(data.franchise_id),
  name: String(data.franchise_title),
  is_default: 1 as TBooleanInNumber,
  autoOnlinePayment: Boolean(data.auto_accept_online_payment),
  subChannel: String(data.sub_channel),
  enabled: Boolean(data.enabled),
  isProductionKey: Boolean(data.isProductionKey),
  secretProdKey: String(data.secretProdKey),
  publicProdKey: String(data.publicProdKey),
  secretSandboxKey: String(data?.secretSandboxKey ?? ''),
  publicSandboxKey: String(data?.publicSandboxKey ?? ''),
  branches: data.branches.map((branch: any) => ({
    id: Number(branch.id),
    name: branch.name as TTranslate,
    createdIn: String(branch.created_in),
    foodicsId: branch.foodics_id ? String(branch.foodics_id) : null,
    franchiseId: Number(branch.franchise_id),
    isBusy: Boolean(branch.is_busy),
  })) as TProfileBranches[],
});

type TProfileBranches = {
  id: number;
  name: TTranslate;
  createdIn: string;
  foodicsId: string;
  franchiseId: number;
  isBusy: boolean;
};

export type CheckoutProfile = ReturnType<typeof checkoutProfileCast>;
